import React from 'react'
import '../CSS/aboutCounsellor.css'
import Card from "@material-tailwind/react/Card";
import CardImage from "@material-tailwind/react/CardImage";
import CardBody from "@material-tailwind/react/CardBody";
import H6 from "@material-tailwind/react/Heading6";
import Paragraph from "@material-tailwind/react/Paragraph";
import '../CSS/Counsellors_page.css'
import { Link } from 'react-router-dom'
import Button from "@material-tailwind/react/Button";
import profilePhoto from '../img/profilePhoto.png'
import CounsellorsSidebar from './CounsellorsDashBoared/CounsellorsSidebar'
const AboutTheCoun = () => {

    return (
        <div className="aboutCounsellor">
            <div className="counsNav">
                <CounsellorsSidebar/>
            </div> 
           <div className="aboutCounsellorDiv">
                <div className="aboutCounsellorUp">
                    <div className="counsellorDetailAndBtn">
                    
                        <div className="counsellorInfo">
                            <div className='cards_div'>
                                <Card className='card'>
                                    <div className="cardCounsellorDetails">
                                        <div className="cardImageDiv">
                                            <CardImage className='card_img' src={profilePhoto} alt="Card"/>
                                        </div>
                                        <div className="cardDetailsCons">
                                            <CardBody>
                                                <H6 className="Counsellor_Name" color="gray">Mr. Shown</H6>
                                                <h2 className="Counsellor_Study"color="gray"><i className="fas fa-briefcase"></i>Psychologist</h2>
                                                <h2 className="Counsellor_exp"color="gray"><i className="fas fa-building"></i>10 Years</h2>
                                                <h2 className="Counsellor_qual"><i className="fas fa-portrait"></i>P.H.D, M.Tech</h2>
                                                <Paragraph color="gray">Always laugh when you can, it is cheap medicine.</Paragraph>
                                            </CardBody>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>

                        <div className="bookAppointmentButton">
                            <Button color="lightBlue" buttonType="filled" size="regular" iconOnly={false} ripple="light">
                                <Link to='/select_mode'>Book an Appointment</Link>
                            </Button> 
                        </div>

                    </div>

                    <div className="counsellorSkillsAbout">
                        <div className="aboutCo">
                            <h2>About Mr. Shown</h2>
                            <p>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</p>
                        </div>

                        <div className="skillsCo">
                        
                            <ol>
                                <h1>Skills :</h1>
                                <li>HTML</li>
                                <li>CSS</li>
                                <li>JavaScript</li>
                                <li>React</li>
                            </ol>
                        </div>
                    </div>
                </div>

                <div className="aboutCounsellorDown">
                    <h1>Reviews : </h1>
                        <div className="aboutCounsellorDownReview">
                        
                            <div className="aboutCounsellorDownRight">
                                 <div className="imgAndNameDiv">
                                    <img src={profilePhoto} alt="ReviewerImg" />
                                    <div className="nameAndRating">
                                        <h2>Mr. Robot</h2>
                                        <p>⭐⭐⭐⭐⭐</p>
                                    </div>
                                </div>
                                <div className="reviewerCommentDiv">
                                    <p>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</p>
                                </div>
                            </div>

                            <div className="aboutCounsellorDownRight">
                                <div className="imgAndNameDiv">
                                    <img src={profilePhoto} alt="ReviewerImg" />
                                    <div className="nameAndRating">
                                        <h2>Mr. Robot</h2>
                                        <p>⭐⭐⭐⭐⭐</p>
                                    </div>
                                </div>
                                <div className="reviewerCommentDiv">
                                    <p>Chat anonymously with an expert of your choice. This service is available to you anytime, anywhere.</p>
                                </div>
                            </div>
                    </div>
                </div>
           </div>
        </div>
    )
}

export default AboutTheCoun
